module.exports = __webpack_public_path__ + "img/f.f508dfc6.jpg";